module.exports = __webpack_public_path__ + "img/workjg.dc156e6f.png";